// Gestione filtri come in Adviva
const filterManager = {
    check_input: "",
    group: {
        class: ".PM_ASCriterionsGroup",
        inner: ".PM_ASCriterionsGroupOuter",
        block: ".PM_ASBlockOutput"
    },
    checked_class: "ischecked",
    active_class: "active",
    opened_class: "opened",
    default_first_active: false,
    default_closed: true,
    expandable: true,
    expand_active: false,

    init() {
        console.log('[CategoryFilter] init() chiamato');
        this.check_input = $(".PM_ASCriterionGroupCheckbox .checkbox input");
        this.group.wrap = $(this.group.class);
        this.group.title = $(".PM_ASCriterionsGroupTitle");
        console.log('[CategoryFilter] Elementi trovati:', {
            check_input: this.check_input.length,
            group_wrap: this.group.wrap.length,
            group_title: this.group.title.length
        });
        this.manageDOM();
        this.manageChecked();
        if (this.expandable) {
            this.manageClick();
        }
    },

    manageDOM() {
        const self = this;
        console.log('[CategoryFilter] manageDOM() chiamato');
        // Wrappa gli input checkbox con <span class="checker"></span>
        const alreadyWrapped = this.check_input.closest('.checker').length;
        const toWrap = this.check_input.length - alreadyWrapped;
        console.log('[CategoryFilter] Checkbox da wrappare:', toWrap, '(già wrappati:', alreadyWrapped, ')');
        if (toWrap > 0) {
            this.check_input.not('.checker input').wrap('<span class="checker"></span>');
        }

        // I dropdown sono nascosti di default dal CSS (display: none)
        // Non serve chiamare .hide() qui, il CSS gestisce tutto
        let hiddenCount = 0;
        this.group.wrap.each(function (index, element) {
            if (!$(element).hasClass("PM_ASCriterionsGroupPrice")) {
                // Il CSS gestisce display: none di default
                hiddenCount++;
            }
        });
        console.log('[CategoryFilter] Dropdown da gestire:', hiddenCount);
    },

    manageChecked() {
        const self = this;
        console.log('[CategoryFilter] manageChecked() chiamato');
        // Rimuove la classe active da tutti i gruppi
        this.group.wrap.removeClass(this.active_class);

        // Gestisce gli stati checked
        let checkedCount = 0;
        this.check_input.each(function (index, element) {
            if ($(element).is(":checked")) {
                checkedCount++;
                // Aggiunge la classe ischecked al checkbox
                $(element).closest(".checkbox").addClass(self.checked_class);
                // Aggiunge la classe opened al gruppo
                $(element).parents(self.group.class).addClass(self.opened_class);
                // Se expand_active è true, mostra il dropdown
                if (self.expand_active) {
                    $(element).parents(self.group.class).find(self.group.inner).show();
                }
            } else {
                // Rimuove la classe ischecked
                $(element).closest(".checkbox").removeClass(self.checked_class);
            }
        });
        console.log('[CategoryFilter] Checkbox checked trovati:', checkedCount);

        // Gestisce il primo elemento attivo se default_first_active è true
        if (this.default_first_active) {
            if (!this.group.wrap.hasClass(this.active_class)) {
                this.group.wrap.first().addClass(this.active_class).find(this.group.inner).slideToggle();
            }
        } else if (!this.default_closed) {
            // Se default_closed è false, apre tutti i dropdown tranne quelli di tipo Price
            this.group.wrap.each(function (index, element) {
                if (!$(element).hasClass("PM_ASCriterionsGroupPrice")) {
                    $(element).addClass(self.active_class).find(self.group.inner).slideToggle();
                }
            });
        }
    },

    manageClick() {
        const self = this;
        console.log('[CategoryFilter] manageClick() chiamato, elementi con listener:', this.group.title.length);

        // Rimuove i listener precedenti per evitare duplicati
        $(document).off('click.categoryFilter', '.PM_ASCriterionsGroupTitle, .PM_ASCriterions');

        // Gestisce il click sui titoli O sul div PM_ASCriterions per aprire/chiudere i dropdown
        // Usa event delegation per gestire anche elementi aggiunti dinamicamente
        $(document).on('click.categoryFilter', '.PM_ASCriterionsGroupTitle, .PM_ASCriterions', function (e) {
            const clicked = $(e.target);
            const title = clicked.closest('.PM_ASCriterionsGroupTitle');
            const criterions = clicked.closest('.PM_ASCriterions');

            // Non gestire click su link o checkbox
            if (clicked.is('a.PM_ASLabelLink') || clicked.closest('a.PM_ASLabelLink').length > 0) {
                console.log('[CategoryFilter] Click su link, ignorato');
                return;
            }
            if (clicked.is('input[type="checkbox"]') || clicked.closest('input[type="checkbox"]').length > 0) {
                console.log('[CategoryFilter] Click su checkbox, ignorato');
                return;
            }

            // Se il click è sul titolo o dentro PM_ASCriterions (ma non su link/checkbox)
            if (title.length > 0 || criterions.length > 0) {
                e.preventDefault();
                e.stopPropagation();

                console.log('[CategoryFilter] Click handler chiamato!', {
                    isTitle: title.length > 0,
                    isCriterions: criterions.length > 0,
                    clickedElement: clicked[0].tagName,
                    clickedClasses: clicked.attr('class') || 'nessuna'
                });

                // Trova il gruppo padre
                const group = (title.length > 0 ? title : criterions).parents(self.group.class);

                if (group.length === 0) {
                    console.log('[CategoryFilter] Gruppo non trovato!');
                    return;
                }

                const isActive = group.hasClass(self.active_class);
                console.log('[CategoryFilter] Click su filtro, gruppo:', group.attr('id') || 'N/A', 'era attivo:', isActive);

                // Chiudi tutti gli altri dropdown prima di aprire questo
                if (!isActive) {
                    // Se stiamo aprendo questo, chiudi tutti gli altri
                    self.group.wrap.each(function (index, element) {
                        const otherGroup = $(element);
                        if (otherGroup[0] !== group[0] && otherGroup.hasClass(self.active_class)) {
                            console.log('[CategoryFilter] Chiudo altro dropdown:', otherGroup.attr('id') || 'N/A');
                            otherGroup.removeClass(self.active_class);
                            otherGroup.find(self.group.inner).slideUp(300);
                        }
                    });
                }

                group.toggleClass(self.active_class);
                const inner = group.find(self.group.inner);
                const isVisible = inner.is(':visible');
                console.log('[CategoryFilter] Toggle dropdown, display attuale:', inner.css('display'), 'isVisible:', isVisible);

                if (isVisible) {
                    inner.slideUp(300);
                } else {
                    inner.slideDown(300);
                }

                console.log('[CategoryFilter] Dopo toggle, classe active:', group.hasClass(self.active_class));
            }
        });
    },

    setActiveFiltersPos() {
        console.log('[CategoryFilter] setActiveFiltersPos() chiamato');
        const selections = $("#aps_search-filter-wrap .PM_ASSelections");
        const cardBlock = $(".PM_ASBlockOutput .card-block");
        console.log('[CategoryFilter] Elementi trovati:', {
            selections: selections.length,
            cardBlock: cardBlock.length
        });
        if (selections.length > 0 && cardBlock.length > 0) {
            cardBlock.append(selections);
            console.log('[CategoryFilter] Filtri attivi spostati');
        } else {
            console.log('[CategoryFilter] Nessun elemento da spostare');
        }
    }
};

// Inizializza quando il documento è pronto
$(document).ready(function () {
    console.log('[CategoryFilter] DOM ready, inizializzazione...');
    // Aspetta che il modulo finisca di inizializzarsi
    setTimeout(function () {
        filterManager.init();
        filterManager.setActiveFiltersPos();
    }, 100);
});

// Inizializza dopo che il modulo ha inizializzato un blocco di ricerca
$(document).on("as4-After-Init-Search-Block", function (event, id_search, search_method, step_search) {
    console.log('[CategoryFilter] Evento as4-After-Init-Search-Block ricevuto, id_search:', id_search);
    filterManager.init();
    filterManager.setActiveFiltersPos();
});

// Reinizializza dopo gli aggiornamenti AJAX del modulo
$(document).on("as4-After-Set-Results-Contents", function (event, id_search, context) {
    console.log('[CategoryFilter] Evento as4-After-Set-Results-Contents ricevuto, id_search:', id_search);
    filterManager.init();
    filterManager.setActiveFiltersPos();
});

$(document).on("as4-Before-Set-Results-Contents", function () {
    console.log('[CategoryFilter] Evento as4-Before-Set-Results-Contents ricevuto');
    // Evento prima dell'aggiornamento (se necessario)
});
